import React from 'react';

function About() {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-images">
            <div className="about-img img-1">
              <img 
                src="https://images.unsplash.com/photo-1556910103-1c02745a30bf?w=800&q=80" 
                alt="甜品制作"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '🎂';
                }}
              />
            </div>
            <div className="about-img img-2">
              <img 
                src="https://images.unsplash.com/photo-1514517604298-cf80e0fb7f1e?w=600&q=80" 
                alt="精致甜品"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '🍰';
                }}
              />
            </div>
            <div className="about-float">
              <span>15年</span>
              <small>匠心制作</small>
            </div>
          </div>
          <div className="about-content">
            <span className="section-label">关于我们</span>
            <h2 className="section-title">传承法式甜品艺术</h2>
            <p className="about-text">
              Sweet Atelier 创立于2010年，由一群热爱甜品的年轻人创立。我们相信，真正的甜品不仅仅是美味，更是一种生活态度的表达。
            </p>
            <p className="about-text">
              我们精选全球优质食材，严格把控每一个制作环节，只为给您带来最纯正的法式甜品体验。
            </p>
            <div className="about-features">
              <div className="feature">
                <div className="feature-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                    <path d="M2 17l10 5 10-5M2 12l10 5 10-5"/>
                  </svg>
                </div>
                <div className="feature-text">
                  <h4>天然食材</h4>
                  <p>进口奶油、新鲜水果</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M12 6v6l4 2"/>
                  </svg>
                </div>
                <div className="feature-text">
                  <h4>新鲜制作</h4>
                  <p>每日现做，保证新鲜</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                  </svg>
                </div>
                <div className="feature-text">
                  <h4>匠心制作</h4>
                  <p>15年经验师傅主理</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
